import { render, staticRenderFns } from "./Advance.vue?vue&type=template&id=35169720&scoped=true&"
import script from "./Advance.vue?vue&type=script&lang=js&"
export * from "./Advance.vue?vue&type=script&lang=js&"
import style0 from "./Advance.vue?vue&type=style&index=0&id=35169720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35169720",
  null
  
)

export default component.exports